import { createContext, useMemo, useReducer } from 'react';

import { AuthReducer } from './reducer/AuthReducer';
import { initialState } from './store/AuthStore';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, initialState);

  const authProviderValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  return <AuthContext.Provider value={authProviderValue}>{children}</AuthContext.Provider>;
};
